import { UIColor, UIText, UITypography } from '@perpetua1/oasis-react';
import React from 'react';
import { Link } from 'gatsby';
import Markdown from '../Markdown';

const shortcodes = {
  p: ({ children }) => (
    <UIText
      className="pt-5 text-left !font-normal"
      typography={UITypography.body}
      color={UIColor.grayLight2}
    >
      {children}
    </UIText>
  ),
  a: ({ href, children }) => (
    <Link className="text-indigo-1" to={href}>
      {children}
    </Link>
  ),
};

interface TermsAndConditionsProps {
  content: string;
}

const TermsAndConditions: React.FC<TermsAndConditionsProps> = ({ content }) => {
  return (
    <div>
      <Markdown shortcodes={shortcodes}>{content}</Markdown>
    </div>
  );
};

export default TermsAndConditions;
